import './polyfills.js';
import '@cof/refi-web-sdk/dist/components/refi-components.js';
import './app/shared/shared.js';
import './app/app.component.js';
import { defineRefiElement } from '@cof/refi-web-sdk/dist/utils/define-refi-element.js';
import { RefiDocViewer } from '@cof/refi-web-sdk/dist/components/doc-viewer/doc-viewer.component.js';

defineRefiElement('esign-doc-viewer', class EsignDocViewer extends RefiDocViewer {});
